import { render, staticRenderFns } from "./AccountResult.vue?vue&type=template&id=154fb6aa&scoped=true&"
import script from "./AccountResult.vue?vue&type=script&lang=ts&"
export * from "./AccountResult.vue?vue&type=script&lang=ts&"
import style0 from "./AccountResult.vue?vue&type=style&index=0&id=154fb6aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154fb6aa",
  null
  
)

export default component.exports